import React, { useState } from "react";
import { Button, Text, ActionIcon } from "@mantine/core";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import styles from "./PagingButtons.module.scss";

export default function PagingButtons({
  page,
  setPage,
  blockHeight,
}: {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  blockHeight: number;
}) {
  return (
    <div className={styles.navButtonsWrapper}>
      <Text className={styles.navPageIndex}>Page {page}</Text>
      <ActionIcon
        onClick={() => {
          setPage(page - 1);
        }}
        className={page === 1 ? styles.disabledButton : styles.enabledButton}
        disabled={page == 1}
      >
        <IconChevronLeft className={styles.actionIcon} />
      </ActionIcon>

      <ActionIcon
        onClick={() => {
          setPage(page + 1);
        }}
        disabled={page * 20 >= blockHeight}
        className={
          page * 20 >= blockHeight
            ? styles.disabledButton
            : styles.enabledButton
        }
      >
        <IconChevronRight className={styles.actionIcon} />
      </ActionIcon>
    </div>
  );
}
